module.exports = __webpack_public_path__ + "customFactor_ico@2x.afbdc6465d696d69526ec435af3ac29d.png";